import React from 'react';
import './Footer.scss';
import useRequest from '../../../hooks/useRequest';
import useStore from '../../../store/useStore';
import HorizontalFooter from '../../Organisms/HorizontalFooter/HorizontalFooter';
import SocialMediaFooter from '../../Organisms/SocialMediaFooter/SocialMediaFooter';
import HorizontalLine from '../../Atoms/HorizontalLine/HorizontalLine';
import LegalCopy from '../../Organisms/LegalCopy/LegalCopy';
import GlobalFooter from '../../Organisms/GlobalFooter/GlobalFooter';
import { FOOTER_CLICK_ACTION } from '../../../constants/AnalyticsConstants';
import { FOOTER, HORIZONTAL_FOOTER, LEGAL_COPY, SOCIAL_MEDIA, excludedPagesAnalytics } from '../../../constants/App';
import { FooterProps } from '../../Interfaces/FooterInterface';
import { getFooterDataByType } from './Util';
import { getPageName } from '../../../Utils/pageUtils';

const Footer: React.FC<FooterProps> = ({ apiEndpoint, dataSource, siteName, analytics}) => {
  const { data } = useRequest({
    params: {
      apiEndpoint: apiEndpoint.value,
      datasourceId: dataSource,
      siteName: siteName,
    },
  });
  const { setAttemptTracker, setAnalyticsProducts } = useStore();

  const analyticsHandler = (clickActionName:string, callAttemptTracker=true) => {
    const pageName = getPageName()
    if(excludedPagesAnalytics.includes(pageName)){
      analytics.cardListClick(clickActionName,'footer:')
    }else{
      setAnalyticsProducts({
        clickActionName:clickActionName.trim(),
        startonlineorder: 0,
      });
      if(callAttemptTracker){
        setAttemptTracker([{ name: FOOTER_CLICK_ACTION }]);
      }
    }
    
  };

  const globalFooterData = getFooterDataByType(data, FOOTER);
  const horizontalFooterData = getFooterDataByType(data, HORIZONTAL_FOOTER);
  const socialMediaFooterData = getFooterDataByType(data, SOCIAL_MEDIA);
  const legalCopyData = getFooterDataByType(data, LEGAL_COPY);

  return (
    <>
      <HorizontalLine className="global-footer__divider" ariaHidden={true} />
      <GlobalFooter testAutoId={"global-footer"} apiData={globalFooterData} analyticsHandler={analyticsHandler} />

      <HorizontalLine className="global-footer__divider" ariaHidden={true} />
      <div className="horisocial-footer__container">
        <SocialMediaFooter testAutoId={"socmedia-footer"} apiData={socialMediaFooterData} analyticsHandler={analyticsHandler} />
        <HorizontalFooter testAutoId={"hori-footer"} apiData={horizontalFooterData} analyticsHandler={analyticsHandler} />
      </div>
      <LegalCopy apiData={legalCopyData} />
    </>
  );
};

export default Footer;
